<template>
  <div class="section-title section-title-internal">
    <div class="section-title-icon">
      <router-link to="/indicadores-aps/esf-eap">
        <button><i class="icofont-reply"></i> <span>Voltar</span></button>
      </router-link>
    </div>
    <div class="section-title-info">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
    </div>
    <div class="section-title-btn-help">
      <modal-informacao
        :isIframe="true"
        urlIframe="https://doc.clickup.com/9011510980/p/h/8cj1fp4-2631/2fc51123cde0aa5/8cj1fp4-3671"
        pageIdentifier="mais-acesso-aps"
        :enableBadge="
          Number($store.state.permissoesRaw?.mais_acesso_aps_ajuda || 0) > 0
        "
        :badgeValue="$store.state.permissoesRaw?.mais_acesso_aps_ajuda || 0"
        keyAjuda="mais_acesso_aps_ajuda"
      ></modal-informacao>
    </div>
  </div>
</template>

<script>
import ModalInformacao from '@/components/ModalInformacao.vue'
import { infoHtml } from '../utils.js'

export default {
  name: 'SectionTitle',
  components: {
    ModalInformacao,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  mounted() {},
  data() {
    return {
      text: infoHtml,
    }
  },
  methods: {},
}
</script>

<style></style>
